import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import axios from "axios";

export default function NavBarSuperior() {
    const username = localStorage.getItem("username");
    const [showModal, setShowModal] = useState(false);
    const [newPassword, setNewPassword] = useState("");

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/login";
    };

    const handlePasswordChange = async () => {
        const token = localStorage.getItem("token");
        try {
            await axios.put(`${process.env.REACT_APP_API_URL}/usuarios/cambiar-password`, {
                password: newPassword  
            }, {
                headers: { Authorization: token }
            });
            alert("Contraseña actualizada");
            setShowModal(false);
        } catch (error) {
            console.error("Error cambiando contraseña:", error);
            alert("Error al cambiar la contraseña");
        }
    };

    return (
        <>
            <div style={{
            backgroundColor: "rgb(37,74,128)",
            color: "white",
            height: "50px",
            padding: "0 20px",
            width: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1000
            }} className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
                <img src="/images/logo.jpg" alt="Logo" style={{ height: "30px" }} />
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                Sistema de control diario
                </span>
            </div>

            <div className="d-flex align-items-center gap-3">
                <span style={{ fontSize: "14px" }}>Cuidador: {username}</span>
                <button className="btn btn-light btn-sm" onClick={() => setShowModal(true)}>
                Cambiar contraseña
                </button>
                <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
                Cerrar sesión
                </button>
            </div>
            </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Cambiar contraseña</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Nueva contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handlePasswordChange}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
